import { ButtonColors } from 'src/shared/design-system/Buttons';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';
import { Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';
import { FollowColors } from '../FollowToggleIcon';
import { StyledButton } from './StyledButton';

export const Button = styled(StyledButton).attrs(({ color, followingColor, isFollowing }) => ({
  color:
    isFollowing && followingColor === FollowColors.WHITE ? ButtonColors.DARK_GRAY : color || ButtonColors.LIGHT_GRAY,
}))<{ followingColor?: FollowColors; iconOnly?: boolean; isFollowing?: boolean }>`
  padding: ${Spacing.HALF} ${Spacing.SINGLE};
  ${Mixins.Flex.center()}

  ${ifProp(
    'iconOnly',
    css`
      padding: ${Spacing.HALF};
      & svg {
        transform: translateY(1px);
      }
    `
  )}

  ${({ followingColor, isFollowing }) =>
    match({ followingColor, isFollowing })
      .with(
        { followingColor: FollowColors.WHITE, isFollowing: true },
        () =>
          css`
            color: ${Colors.WHITE};
          `
      )
      .otherwise(() => '')}
`;

export const ButtonText = styled.div`
  margin-left: ${Spacing.HALF};
`;

export const Container = styled.div<{ isSmallScreen?: boolean }>`
  align-items: center;
  display: flex;
  font-size: ${Font.Size.S};
  font-weight: 500;
  line-height: ${Font.LineHeight.S};

  ${ifProp(
    'isSmallScreen',
    css`
      padding: ${Spacing.QUARTER};
    `,
    css`
      padding: 0 ${Spacing.QUARTER};
    `
  )}

  & svg {
    margin-right: ${Spacing.HALF};
  }
`;
